export const FEMALE_DR_AVATAR = "/assets/avatar/user.png";
export const MALE_DR_AVATAR = "/assets/avatar/user.png";
export const HEADER_AVATAR = "/assets/avatar/header.png";
export const FOOTER_AVATAR = "/assets/avatar/footer.png";
export const SIDE_AVATAR = "/assets/avatar/side.png";
export const WATERMARK_AVATAR = "/assets/avatar/watermark.png";
export const ERROR_IMG = "/assets/avatar/user.png";
export const INIT_TITLE = "Doctora | Digital OPD to Connect with doctors";
export const PAGE_SIZE = 20;
export const PUBLIC_PAGE_SIZE = 12;
export const DOCTOR_URL = "https://doctora.live/#/doctor/";
export const CHECK_URL = "https://doctora.live/#/checkconfirmed/";

//export const IsMobileEnv = true
export const IsMobileEnv = false

//Live Api
export const BASE_URL = "https://api.secured.doctora.live/";
export const BASE_URL_API = "https://api.secured.doctora.live/api";
export const LIVE_URL = "https://api.secured.doctora.live/opdlive"

//Local Api
// export const BASE_URL = "https://localhost:44302/";
// export const BASE_URL_API = "https://localhost:44302/api";
// export const LIVE_URL = "https://localhost:44302/opdlive"
